import DateRangePickerModal from "./date-range-picker";

export default DateRangePickerModal;
